import { OrganisationTypeConstants } from "../../../../../constants";
import {
  AssetManagerSingleCardTemplate,
  AuditChangesPanelTemplate,
  DeveloperSingleCardTemplate,
} from "../../../../../templates";
import { useAuth } from "../../../../../useAuth";
import { Column, CursorDataGrid, Row } from "../../../../../widget";
import { useAuditHistory } from "./useAuditHistory";

export const AuditHistory = (): JSX.Element => {
  const { currentUserType } = useAuth();
  const {
    projectDisplayName,
    exportFileName,
    handleBackClick,
    columns,
    defaultSortingCriteria,
    dataIsLoading,
    auditDataUuid,
    auditDataChange,
    showAuditChangesPanel,
    setShowAuditChangesPanel,
    onChange,
  } = useAuditHistory();
  const isAssetManager = currentUserType === OrganisationTypeConstants.ASSET_MANAGER;
  const content = (
    <>
      <Row spacingV="ll">
        <Column span={9}>
          <h2>{projectDisplayName}</h2>
        </Column>
      </Row>
      <CursorDataGrid
        columns={columns}
        clientSide={false}
        filterable
        onChange={onChange}
        data={[]}
        noDataMessage="No audit data to display"
        dataIsLoading={dataIsLoading}
        defaultSortingCriteria={defaultSortingCriteria}
        exportable
        exportFileName={exportFileName}
        variant={isAssetManager ? "seed" : "default"}
      />
    </>
  );

  return (
    <div className="ProjectAuditHistoryDetails">
      {projectDisplayName &&
        (isAssetManager ? (
          <AssetManagerSingleCardTemplate
            pageTitle="Audit History"
            handleBackClick={handleBackClick}
            backButtonText="Back to full project"
            activeElement="Portfolio"
          >
            {content}
          </AssetManagerSingleCardTemplate>
        ) : (
          <DeveloperSingleCardTemplate
            pageTitle="Audit History"
            handleBackClick={handleBackClick}
            backButtonText="Back to full project"
            activeElement="Projects"
          >
            {content}
          </DeveloperSingleCardTemplate>
        ))}
      {auditDataUuid && (
        <AuditChangesPanelTemplate
          auditDataUuid={auditDataUuid}
          auditDataChange={auditDataChange}
          show={showAuditChangesPanel}
          onClose={() => setShowAuditChangesPanel(false)}
        />
      )}
    </div>
  );
};
